import { PATHS, trackMixpanelEvent, useRouter } from '@belong/common';
import { OverlayWithHeader, Link, Text } from '@belong/ui';

export function FlowHeaderMobile({
  isOverlayOpen,
  closeOverlayModal,
  exitHref,
}: FlowHeaderMobileProps): JSX.Element {
  const { pathname } = useRouter();

  const handleExitClick = () => {
    if (pathname.includes('/rent-estimate/')) {
      trackMixpanelEvent('flow-exited', {
        flowType: 'RentEstimate',
        stepEnum: pathname.split('/').pop() || 'unknown',
      });
    }
  };

  return (
    <OverlayWithHeader
      name="mobile_navigation"
      isOpen={isOverlayOpen}
      onDismiss={closeOverlayModal}
    >
      <div className="pt-xl container">
        <div className="mb-xl">
          <Link href={PATHS.SUPPORT}>
            <Text as="span" variant="h3" fontWeight="semibold">
              GET HELP
            </Text>
          </Link>
        </div>

        <div className="mb-xl">
          <Link href={exitHref} onClick={handleExitClick}>
            <Text as="span" variant="h3" fontWeight="semibold">
              EXIT
            </Text>
          </Link>
        </div>
      </div>
    </OverlayWithHeader>
  );
}

type FlowHeaderMobileProps = {
  isOverlayOpen: boolean;
  closeOverlayModal: () => void;
  exitHref: string;
};
